
import Vue from "vue";
import AppSidebarContactDetailsBlock from "./SidebarContactDetailsBlock.vue";
import { BrowseStateBase } from "@/utils/browse/browse-state-base";

export default Vue.extend({
	props: {
		item: {
			type: Object as () => any,
			required: true
		},
		state: {
			type: Object as () => BrowseStateBase,
			required: true
		}
	},
	computed: {
		loaded():boolean {
			return this.state.sidebarItemLoaded;
		},
		contact():any {
			let contact = this.item.Contact;
			if (!contact || !contact.ID) return null;
			return contact;
		}
	},
	components: {
		AppSidebarContactDetailsBlock
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
